import Box from '@mui/material/Box';

import { useBoolean } from '@zeta-core';
import Main from './main';
import NavVertical from './nav-vertical';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function SignUpAdvisorLayout({ children }: Props) {
  const nav = useBoolean();

  const renderNavVertical = <NavVertical openNav={nav.value} />;

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      {renderNavVertical}
      <Main>{children}</Main>
    </Box>
  );
}
